import { styled } from '@linaria/react';

interface ITagProps {
  display?: string;
}

export const Tag = styled.div<ITagProps>`
  display: ${(props) => (props.display ? props.display : 'block')};
`;
